import { Box, Button, Divider, Stack, useTheme } from "@mui/material";
import { PlusIcon } from "lucide-react";
import type { FC } from "react";
import type { DocumentDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DocumentItemRedesign } from "web_myplann/Portfolio/Components/Redesign/Documents/DocumentItemRedesign";
import { RedesignListBackground } from "web_myplann/Shared/Components/Redesign/RedesignListBackground";

const R = Resources.Portfolio.List.Redesign.Documents;

type Props = {
	documents: DocumentDTO[];
	folder?: string;
	onAddDocument: () => void;
};

export const FolderDocumentList: FC<Props> = ({
	documents,
	folder,
	onAddDocument,
}) => {
	const { palette, iconSize, spacingTokens } = useTheme();
	const { t } = useResource();

	return (
		<RedesignListBackground pt={spacingTokens.sm}>
			<Stack
				bgcolor={palette.background.paper}
				divider={<Divider sx={{ borderColor: palette.grey[100] }} />}
			>
				{documents.map((document) => (
					<DocumentItemRedesign
						key={document.id}
						item={document}
						activeTag={folder}
						showFileSize
					/>
				))}
			</Stack>

			<Box px={spacingTokens.lg} mt={spacingTokens.xl}>
				<Button
					variant="secondary"
					startIcon={<PlusIcon size={iconSize.md} />}
					onClick={onAddDocument}
					sx={{ color: palette.blue[600] }}
				>
					{t(R.addDocument)}
				</Button>
			</Box>
		</RedesignListBackground>
	);
};
